"use strict";

PF.Field.MapPoint = class MapPoint extends PF.Field
	{

	static get options()
		{

		return {
			html: PF.Field.MapPoint.templates,
			popupConfig: {
				title: 'Установите координаты'
			},
			mapDefault: {
				lat: 55.73397910012475,
				lng: 37.64455373793694,
				zoom: 11
			},
			// Томск:
			// mapDefault: {
			// 	lat: 56.49194588506882,
			// 	lng: 84.98186895841935,
			// 	zoom: 12
			// },

			label: "Координаты",
			model: new PF.Model({}),
			keyLat: 'lat',
			keyLng: 'lng',
			keyZoom: 'zoom',

			showInfo: true,
			helper: '',

			errors: {}
		};
		}


	static get templates()
		{
		return {
			//language=HTML
			wrapper: `
				<div class="pf-select-wrapper">
					<div class="pf-select" pf="select">
						<div class="pf-select-label" pf="label"></div>
						<div class="pf-selected" pf="selected">
							<div class="item-inner">
								<div class="item-title" pf="title">
								</div>
							</div>
						</div>
					</div>
					<div class="underline">
						<hr class="normal"/>
						<hr class="focus"/>
					</div>
					<div class="info" pf="info">&nbsp;</div>
				</div>
			`,
			//language=HTML
			popupContent: `
				<div class="" style="height: 100%">
					<div class="" pf="map" style="width:100%; height:calc(100% - 67px)">
					</div>
					<form class="block row" pf="form" style="margin: 0">
						<div class="col-33">
							<input type="text" pf="lat"\>
						</div>
						<div class="col-33">
							<input type="text" pf="lng"\>
						</div>
						<div class="col-33">
							<input type="text" pf="zoom"\>
						</div>
					</form>
				</div>
			`,
		};
		}

	init()
		{
		this.dom.loads(this.html);
		this.dom.element.append(this.dom.wrapper);

		this.popup = new PF.F7Popup({
			dom: {content: this.dom.popupContent},
			...this.popupConfig
		});
		this.popup.on('opened', () => {
			if (this.map === undefined)
				{
				this.initMap();
				}
		});

		this.dom.select.on('click', () => this.popup.open());

		this.calc('isSet', [
				{object: this.model, key: this.keyLat},
				{object: this.model, key: this.keyLng},
				{object: this.model, key: this.keyZoom},
			],
			(l, n, z) => l !== null && l !== undefined && n !== null && n !== undefined /*&& z !== null && z !== undefined*/);

		this.form = new PF.Form({
			dom: {element: this.dom.form},
			model: this.model,
			fieldsConfig: {
				lat: {
					index: this.keyLat,
					class: PF.Field.Float,
					required: true,
					label: 'Широта'
				},
				lng: {
					index: this.keyLng,
					class: PF.Field.Float,
					required: true,
					label: 'Долгота'
				},
				zoom: {
					index: this.keyZoom,
					class: PF.Field.Int,
					required: true,
					label: 'Масштаб карты'
				},
			}
		});

		this.bindDom({wrapper: 'class:error'}, 'error', (e) => e !== '');
		this.bindDom({wrapper: 'class:focus'}, 'popup.opened');
		this.bindDom({info: 'html'}, ['helper', 'error'], (h, e) => e !== '' ? e : h !== '' ? h : '&nbsp;');
		this.bindDom({info: 'show'}, 'showInfo');
		this.bindDom({label: 'html'}, 'label');
		this.bindDom({select: 'class:active'}, 'isSet');
		this.bindDom({title: 'html'}, ['isSet', 'model.lat', 'model.lng'], (isSet, l, n) => isSet ? `Широта: ${PF.H.round(l,-5)}, долгота: ${PF.H.round(n,-5)}` : '&nbsp;');
		}

	reviewValue()
		{
		let valueModel = this.model.get(this.key, new PF.Model({raw: null}), new PF.Model({raw: null}));
		if (valueModel.isNull() === true || this.group.selected === null)
			{
			this.dom.selected.html('&nbsp;');
			this.dom.select.removeClass('active');
			}
		else
			{
			this.dom.selected.html(this.group.selected.itemInner);
			MK.parseBindings(this.group.selected, this.dom.selected);
			this.dom.select.addClass('active');
			}
		this.popup.close();
		}

	initMap()
		{
		if (this.isSet)
			{
			this.map = new ymaps.Map(this.dom.map.node, {
				center: [this.model.get(this.keyLat), this.model.get(this.keyLng)],
				zoom: this.model.get(this.keyZoom, this.mapDefault.zoom, this.mapDefault.zoom), ...app.mapConfig
			});
			this.createMarker([this.model.get(this.keyLat), this.model.get(this.keyLng)]);
			}
		else
			{
			this.map = new ymaps.Map(this.dom.map.node, {center: [this.mapDefault.lat, this.mapDefault.lng], zoom: this.mapDefault.zoom, ...app.mapConfig});
			}

		this.map.events.add('click', this.mapClickSlot.bind(this));
		this.map.events.add('boundschange', () => this.model.set(this.keyZoom, this.map.getZoom()));

		this.model.on('changed:' + this.keyLat, () => this.setMarkerCords());
		this.model.on('changed:' + this.keyLng, () => this.setMarkerCords());
		this.model.on('changed:' + this.keyZoom, () => this.map.setZoom(this.model[this.keyZoom]));
		}

	mapClickSlot(event)
		{
		let coords = event.get('coords');

		if (!this.isSet)
			{
			this.createMarker(coords);
			}
		else
			{
			this.marker.geometry.setCoordinates(coords);
			}
		this.model.setData(this.keyLat, coords[0]);
		this.model.setData(this.keyLng, coords[1]);
		this.model.setData(this.keyZoom, this.map.getZoom());
		}

	createMarker(coords)
		{
		this.marker = new ymaps.Placemark(coords, {}, {
			draggable: true,
			// ...app.markerOption
		});
		this.map.geoObjects.add(this.marker);
		this.marker.events.add('dragend',
			() => {
				let coords = this.marker.geometry.getCoordinates();
				this.model.setData(this.keyLat, coords[0]);
				this.model.setData(this.keyLng, coords[1]);
				this.model.setData(this.keyZoom, this.map.getZoom());
			});
		}

	setMarkerCords()
		{
		if (this.isSet)
			{
			if (this.marker !== undefined)
				{
				this.marker.geometry.setCoordinates([this.model.get(this.keyLat), this.model.get(this.keyLng)]);
				this.map.setZoom(this.model.get(this.keyZoom, this.mapDefault.zoom, this.mapDefault.zoom));
				this.map.panTo([this.model.get(this.keyLat), this.model.get(this.keyLng)]);
				}
			}
		}


	};
